import { createMapIntentType } from './createMapIntentType';
export const provider = createMapIntentType('provider', (decorate)=>(context, value)=>{
        return decorate([
            context,
            value
        ]);
    }, ([context])=>context);

//# sourceMappingURL=provider.js.map